import script from "./EcommerceComplaintsBook.vue?vue&type=script&setup=true&lang=js"
export * from "./EcommerceComplaintsBook.vue?vue&type=script&setup=true&lang=js"

import "./EcommerceComplaintsBook.vue?vue&type=style&index=0&id=759f9d31&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\unensecommerce\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-759f9d31"]])

export default __exports__